// Set REACT_APP_API_URL at BUILD time (CRA inlines it). Set it to an empty
// string when nginx serves this bundle and proxies /api to the admin backend on
// the same origin — that is how the Docker image is built. Unset means local
// development against a backend on :3001.
const API_BASE = process.env.REACT_APP_API_URL ?? 'http://localhost:3001';

export function getToken(): string | null {
  try { return localStorage.getItem('admin_token'); } catch { return null; }
}

export function setToken(token: string): void {
  try { localStorage.setItem('admin_token', token); } catch { /* ignore */ }
}

export function clearToken(): void {
  try { localStorage.removeItem('admin_token'); } catch { /* ignore */ }
}

export async function fetchApi<T>(path: string, options: RequestInit = {}): Promise<T> {
  const token = getToken();
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...((options.headers as Record<string, string>) || {}),
  };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(`${API_BASE}${path}`, { ...options, headers });

  if (!res.ok) {
    if (res.status === 401) {
      clearToken();
      window.location.reload(); // Force re-login
      throw new Error('Session expired. Please log in again.');
    }
    const err = await res.json().catch(() => ({ message: res.statusText }));
    throw new Error(err.message || `API error ${res.status}`);
  }

  return res.json();
}

/**
 * Same auth handling as fetchApi, but for a binary response (an identity
 * document image) rather than JSON — a plain `<img src>` can't carry the
 * Bearer token this API requires, so the caller fetches the bytes here and
 * turns them into an object URL instead. See AuthenticatedImage.tsx.
 */
export async function fetchApiBlob(path: string): Promise<Blob> {
  const token = getToken();
  const headers: Record<string, string> = {};
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(`${API_BASE}${path}`, { headers });

  if (!res.ok) {
    if (res.status === 401) {
      clearToken();
      window.location.reload();
      throw new Error('Session expired. Please log in again.');
    }
    const err = await res.json().catch(() => ({ message: res.statusText }));
    throw new Error(err.message || `API error ${res.status}`);
  }

  return res.blob();
}

